import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
    initMetaPixel,
    isMetaPixelEnabled,
    metaTrackPageView,
    metaTrackViewContent,
    metaTrackViewContentList
} from '../analytics/metaPixel';
import { mainProduct, products } from '../data/product';

/**
 * Loads Meta Pixel on first run, then PageView on each SPA navigation.
 */
function MetaPixel() {
    const location = useLocation();

    useEffect(() => {
        if (!isMetaPixelEnabled()) return;

        if (!window.__META_PIXEL_INITIALIZED__) {
            initMetaPixel();
        } else {
            metaTrackPageView();
        }

        if (location.pathname === '/') {
            metaTrackViewContentList(products, 'GOUNOD lifting straps');
        } else if (location.pathname === '/premium-strap') {
            metaTrackViewContent(mainProduct);
        }
    }, [location.pathname, location.search]);

    return null;
}

export default MetaPixel;
